import { Alert, Anchor, Group, Text } from '@mantine/core'
import { IconBrandTelegram } from '@tabler/icons-react'
import { Link, useLocation } from 'react-router-dom'
import type { UserDto } from '@ledokol/contracts'

/**
 * Эпик «UI tg-link сотрудника» (T12) P4 — onboarding-gate баннер.
 *
 * **Обязательная** точка входа в /me/telegram для непривязанных сотрудников (план §0 E,
 * §1.4). НЕ «уведомление» — без него человек не узнает что надо привязаться, на боте
 * получит молчание + создание стаба, а нажав [Подтвердить] в группе — 403 «нет прав».
 *
 * **Без дисмисса** (нет «×»): если делать — половина команды закроет и забудет. Дисмиссится
 * только реальной привязкой (после которой условие становится false и компонент рендерит null).
 *
 * **Скрыт на /me/telegram** (anti-loop, ревью P4 #2): `location.pathname.startsWith('/me/telegram')`,
 * не точное равенство — query/sub-paths не должны сломать скрытие. Иначе на целевой странице
 * баннер ведёт сюда же = бесконечный круг визуально.
 *
 * **Условие показа** (факт-чек 2026-06-05, см. commit-сообщение P4):
 *   user.tg_linked_at === null && !user.isStub
 * Корректно для всех 5 сценариев: чистый новичок / промоутнутый стаб (нет UI-привязки) /
 * после reverse-merge с tg_username (admin доверил) / linked обычным двух-шагом / стаб.
 */
export function TgLinkBanner({ user }: { user: UserDto | null }) {
  const location = useLocation()
  if (!user) return null
  if (user.is_stub) return null // стаб = не человек, ему баннер не нужен (и страница тоже не предназначена)
  if (user.tg_linked_at !== null) return null // уже привязан
  if (location.pathname.startsWith('/me/telegram')) return null // anti-loop (ревью P4 #2)

  return (
    <Alert
      color="blue"
      variant="light"
      icon={<IconBrandTelegram size={20} stroke={1.6} />}
      radius={0}
      mb="md"
    >
      <Group justify="space-between" wrap="nowrap" gap="md">
        <Text size="sm">
          <b>Telegram-аккаунт ещё не привязан к CRM.</b> Без привязки задачи из рабочих чатов
          будут с временным «постановщиком» вместо вас, и вы не сможете подтверждать карточки
          задач кнопкой в боте.
        </Text>
        <Anchor component={Link} to="/me/telegram" fw={600} style={{ whiteSpace: 'nowrap' }}>
          Привязать сейчас →
        </Anchor>
      </Group>
    </Alert>
  )
}
